import PaymentsForm from './PaymentsForm';

export default PaymentsForm;
